import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ModalRef, ModalData } from '@purespectrum1/ui/modal';
import { ToasterService } from '@purespectrum1/ui/toaster-service';

import { Subscription } from 'rxjs';

// Services
import { SubscriberService } from '../../../shared/services/subscribers/subscriber.service';

// Interfaces
import { TimeZone } from '../../../shared/interfaces/date';
import {
  Subscriber,
  SubscriberPayload,
} from '../../../shared/services/subscribers/subscriber.interface';

@Component({
  selector: 'ps-ui-subscribe-email-modal',
  templateUrl: './subscribe-email-modal.component.html',
  styleUrls: ['./subscribe-email-modal.component.css'],
})
export class SubscribeEmailModalComponent implements OnInit, OnDestroy {
  private _subscription: Subscription = new Subscription();
  private _surveyId: number = this._modalData.surveyId;

  public form!: FormGroup;
  public timezones: TimeZone[] = [];
  public subscribers: Subscriber[] = [];

  constructor(
    @Inject(ModalData)
    private _modalData: { surveyId: number },
    private _modalRef: ModalRef<SubscribeEmailModalComponent, string>,
    private _fb: FormBuilder,
    private _toastr: ToasterService,
    private _subscriberService: SubscriberService
  ) {}

  ngOnInit(): void {
    this._initForm();
    this._getTimeZones();
    this._getSubscribers();
  }

  private _initForm() {
    this.form = this._fb.group({
      email: [
        null,
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      timezone: [null, [Validators.required]],
    });
  }

  private _getTimeZones() {
    this.timezones = this._subscriberService.getTimeZones();
  }

  private _getSubscribers() {
    this._subscriberService.getSubscribers(this._surveyId).subscribe(
      (response) => {
        this.subscribers = response.subscribers || [];
      },
      (error) => {
        this._toastr.error(error.error.msg);
      }
    );
  }

  public selectTimeZone(timezone: TimeZone) {
    this.form.patchValue({
      timezone: timezone,
    });
  }

  public close(msg?: string) {
    if (msg === 'save') {
      if (this.form.valid) {
        this._saveSubscriber();
      } else {
        this._getFormValidationErrors();
      }
    } else {
      this._modalRef.close();
    }
  }

  public deleteSubscriber(subscriber: Subscriber) {
    this._subscriberService
      .deleteSubscriber(this._surveyId, subscriber.email)
      .subscribe(
        () => {
          this._toastr.success('Subscriber deleted sucessfully!!');
          this.subscribers.indexOf(subscriber) !== -1 &&
            this.subscribers.splice(this.subscribers.indexOf(subscriber), 1);
        },
        (error) => {
          this._toastr.error(error.error.msg);
        }
      );
  }

  private _saveSubscriber() {
    const payload: SubscriberPayload = {
      email: this.form.value.email,
      timezone: this.form.value.timezone.value,
    };
    this._subscriberService.saveSubscriber(this._surveyId, payload).subscribe(
      () => {
        this.form.reset();
        this._toastr.success('Subscriber Saved sucessfully!!');
        this._getSubscribers();
      },
      (error) => {
        this._toastr.error(error.error.msg);
      }
    );
  }

  private _getFormValidationErrors() {
    if (this.form.get('timezone')?.status === 'INVALID') {
      this._toastr.warning('Please select timezone!');
    }
    if (this.form.get('email')?.status === 'INVALID') {
      this._toastr.warning('Please enter a valid email!');
    }
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }
}
